<app-page-layout>
  <h1>API Usage</h1>

  <p>
    Async query jobs can finish with <code>success</code>, <code>partial</code>, or
    <code>error</code>. Completed jobs provide a gzipped CSV result file; small results are
    previewed inline, while larger results are downloaded directly.
  </p>

  <!-- <p>
    Making a query directly to the API is a three-stage process. First, you use your credentials to
    acquire a JSON Web Token that you can save and use for one hour. Once the token expires, you
    will need to request a fresh token.
  </p>

  <p>
    Second, that token needs to be passed in an authorization header to subsequent POST requests to
    the API as demonstrated in the following javascript code:
  </p>

  <pre>
  <code>
  {{code}}
  </code>
</pre>

  <p>
    When the query is submitted, it is put onto a queue, and the response from the http request to
    the endpoint `/api/query` is a JSON object with meta data related to the query:
  </p>

  <pre>
  <code>
  {{ exampleMetaDatum }}
  </code>
</pre>

  <p>
    As the query is processed, the status of the query will get updated, and will end on either
    'success' or 'error'. In the event of success, the results of the query will be posted, and the
    url included in the meta datum.
  </p> -->
</app-page-layout>
